import queryString from 'query-string'

const getExternalQuery = () => {
  const windowlocationSearch = window.location.search
  if (windowlocationSearch) {
    const externalQuery = queryString.parse(windowlocationSearch)
    return externalQuery
  }
  return {}
}

export default getExternalQuery
